import { createAction } from 'redux-actions'

import { DISMISS_NEW, DISMISS_TIMESTAMPED_NEWS } from './constants'

export const dismissNews = createAction(DISMISS_NEW)
export const dismissTimestampedNews = createAction(DISMISS_TIMESTAMPED_NEWS)
